// Quality API extensions — all calls workspace-scoped.
import { AdminAPI } from '@/lib/admin-api';
import { api } from '@/lib/api';
import { getWorkspace } from '@/lib/workspace';

const opts = () => ({ headers: { 'X-Workspace': getWorkspace() } });

AdminAPI.quality = {
  conflicts: (versionId) => api.get(`/api/admin/rule-versions/${versionId}/conflicts`, opts()),
  parityBatteries: () => api.get('/api/admin/parity-batteries', opts()),
  runParity: (cardId, versionId, batteryId) =>
    api.post(`/api/admin/cards/${cardId}/rule-versions/${versionId}/parity`, { battery_id: batteryId || null }, opts()),
  parityHistory: (cardId, limit = 20) => api.get(`/api/admin/cards/${cardId}/parity-history?limit=${limit}`, opts()),
  trace: (body) => api.post('/api/admin/simulate/trace', body, opts()),
};

// Rule-version maintenance endpoints (delete + repair).
// These extend the existing `AdminAPI.rules` namespace defined in admin-api.js
// without overwriting any other keys.
AdminAPI.rules = {
  ...(AdminAPI.rules || {}),
  remove: (versionId) => api.del(`/api/admin/rule-versions/${versionId}`, opts()),
  repair: (cardId) => api.post(`/api/admin/cards/${cardId}/rule-versions/repair`, {}, opts()),
};

AdminAPI.qa = {
  dashboard: () => api.get('/api/admin/qa/dashboard', opts()),
};

export { AdminAPI };
